module.exports = __webpack_public_path__ + "static/media/moon.1dcb6287.jpg";